interface FooterProps {
  onNavigate: (page: 'home' | 'legal' | 'privacy' | 'cookies' | 'terms') => void;
  onErrorReport: () => void;
  t: {
    copy: string;
    confidentiality: string;
    legalNotice: string;
    privacyPolicy: string;
    cookiesPolicy: string;
    termsOfService: string;
    credits: string;
    errorLinkPlaceholder: string;
  }
}

declare const __APP_VERSION__: string;

const Footer = ({ onNavigate, onErrorReport, t }: FooterProps) => {
  return (
    <footer className="bg-slate-900/80 border-t border-slate-800">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8 text-center text-slate-400">
        <p>&copy; {new Date().getFullYear()} {t.copy}</p>
        <p className="text-sm mt-2 mb-6">
            {t.confidentiality}
        </p>
        <div className="flex flex-wrap justify-center gap-4 text-sm mb-6">
            <button onClick={() => onNavigate('legal')} className="hover:text-white transition-colors">{t.legalNotice}</button>
            <span className="hidden sm:inline text-slate-600">|</span>
            <button onClick={() => onNavigate('privacy')} className="hover:text-white transition-colors">{t.privacyPolicy}</button>
            <span className="hidden sm:inline text-slate-600">|</span>
            <button onClick={() => onNavigate('cookies')} className="hover:text-white transition-colors">{t.cookiesPolicy}</button>
            <span className="hidden sm:inline text-slate-600">|</span>
            <button onClick={() => onNavigate('terms')} className="hover:text-white transition-colors">{t.termsOfService}</button>
        </div>
        <p className="text-xs text-slate-500 mb-0.5">
            {t.credits} <span className="ml-1 opacity-70">{__APP_VERSION__}</span>
        </p>
        <button 
          onClick={onErrorReport}
          className="text-xs italic text-slate-500 hover:text-blue-400 transition-colors block mx-auto"
        >
          {t.errorLinkPlaceholder}
        </button>
      </div>
    </footer>
  );
};

export default Footer;